import React from "react";
import { CloseIcon } from 'components';
import { useNavigate } from "react-router-dom";
import { ProfileContainer } from 'pages/addprofile/AddProfile.style';
import BuisnessPlace from ".";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';

const ProfileBusinessList = () => {
    const navigate = useNavigate();
      const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>My Businesses | WafyNet - Manage Your Business Pages</title>
                <meta
                    name="description"
                    content="View and manage the businesses you created on WafyNet. Update your business information and connect with a wider audience."
                />
            </Helmet>
            <ProfileContainer>
                <div className="profile-header">
                    <CloseIcon iconType={"back"} onClick={() => navigate(-1)} />
                    <div className="user-name">{t('HomePage.Back')}</div>
                </div>
                <BuisnessPlace isProfile />
            </ProfileContainer>
        </>
    );
};
export default ProfileBusinessList;
